<template>
  <label
    :class="[
      'inp_func',
      {
        none_text: !hasLabel,
      },
    ]"
  >
    <input type="radio" v-bind="attrs" v-on="listeners" :checked="_checked" />
    <span class="txt"><slot />{{ label }}</span>
  </label>
</template>

<script>
export default {
  model: {
    prop: "model",
    event: "update",
  },
  props: {
    label: String,
    value: [String, Number],
    model: [Number, String],
    checked: Boolean,
  },
  computed: {
    hasLabel() {
      return Boolean(this.label || this.$slots.default);
    },
    attrs() {
      const { model, checked, ...restProps } = this.$props;
      return { ...this.$attrs, ...restProps };
    },

    listeners() {
      return { ...this.$listeners, input: this.onInput };
    },

    _checked() {
      return this.checked || this.value === this.model;
    },
  },

  methods: {
    onInput(e) {
      const checked = e.target.checked;
      this.$emit("update", checked ? this.value : undefined);
    },

    focus() {
      this.$el.querySelectorAll('input,select,textarea')[0]?.focus()
    },
  },
};
</script>

<style>
</style>